import React from "react";

const CloseButton = ({onClick=()=>{}}) => {
    return (
        <div onClick={onClick} style={{cursor: "pointer"}}><i className="fa fa-times"/></div>
    )
}

export default CloseButton;